module.exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


//# sourceMappingURL=sr-SP.main.js.map
